export type FriendrUtmCampaign = 'friendr_share' | 'friendr_email';

export type FriendrUtmParams = {
  medium: 'social' | 'email';
  source: string;
  campaign?: FriendrUtmCampaign;
  content?: string;
};

const DEFAULT_CAMPAIGN: FriendrUtmCampaign = 'friendr_share';

/**
 * Appends GA-friendly UTM query params for Friendr share / email attribution.
 */
export function appendFriendrUtmParams(
  url: string,
  params: FriendrUtmParams,
): string {
  const trimmed = url.trim();
  if (!trimmed) return url;

  try {
    const parsed = new URL(
      trimmed,
      typeof window !== 'undefined' ? window.location.origin : 'https://example.com',
    );
    parsed.searchParams.set('utm_source', params.source);
    parsed.searchParams.set('utm_medium', params.medium);
    parsed.searchParams.set(
      'utm_campaign',
      params.campaign ?? DEFAULT_CAMPAIGN,
    );
    if (params.content?.trim()) {
      parsed.searchParams.set('utm_content', params.content.trim());
    }
    return parsed.toString();
  } catch {
    return url;
  }
}

export function appendSocialShareUtmParams(
  url: string,
  platform: 'facebook' | 'instagram' | 'tiktok',
): string {
  return appendFriendrUtmParams(url, {
    medium: 'social',
    source: platform,
    content: 'match_results',
  });
}

export function appendEmailShareUtmParams(
  url: string,
  content: 'view_in_browser' | 'adoption_application' | 'email_preferences',
): string {
  return appendFriendrUtmParams(url, {
    medium: 'email',
    source: 'friendr',
    campaign: 'friendr_email',
    content,
  });
}
